(() => {
  const update = (elem) => {
    const itemNumber = elem.getAttribute('data-itemnumber');
    const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
    const isAlreadyOwned = window.swinger.user.isLoggedIn() && window.swinger.config.productDeliveryType === 'vod' && itemOwnState && itemOwnState.status === 'purchased';

    const currentPrice = elem.getAttribute('data-currentprice');
    const regularPrice = elem.getAttribute('data-regularprice');
    let priceDropPercent = 0;
    if (currentPrice && regularPrice) {
      priceDropPercent = Math.round((1 - (currentPrice / regularPrice)) * 100);
    }
    const studio = elem.getAttribute('data-studio');
    const studioPromotion = window.swinger.user.getStudioPromotion(studio);

    switch (true) {
      default:
      case !!isAlreadyOwned:
        elem.textContent = '';
        break;

      case !!studio && !!studioPromotion:
        elem.textContent = studioPromotion.label;
        break;

      case priceDropPercent > 30:
        window.swinger.i18n()
          .then((i18n) => {
            elem.textContent = i18n('ui.shared.badge.sale', {
              priceDropPercent,
            });
          })
          .catch(console.info);
        break;
    }

    elem.classList.add('swinger-badge-promotion--show');
  };

  const updateAll = () => window.swinger.$('.swinger-badge-promotion').forEach(update);

  window.swinger.observer.initialize('.swinger-badge-promotion', update, false);

  document.addEventListener('swinger-widget:rendered', updateAll, true);
  document.addEventListener('swinger.user:authchange', updateAll, true);
})();
